import { render } from "./StartPage.vue?vue&type=template&id=5afd4914&scoped=true"
import script from "./StartPage.vue?vue&type=script&lang=js"
export * from "./StartPage.vue?vue&type=script&lang=js"

import "./StartPage.vue?vue&type=style&index=0&id=5afd4914&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afd4914"]])

export default __exports__